module.exports = __webpack_public_path__ + "static/media/logo-alt.75329ae3.svg";